import basePath from "base_path";
import ActionTypes from "../constants/action_types";
import {buildQuery} from "utils/uri";

import createReduxPromiseAction from "utils/create_redux_promise_action";

export default function fetchTopicUsesByTopicId(requestor) {
  return createReduxPromiseAction(
    ActionTypes.TOPIC_USES_BY_TOPIC_ID_FETCH,
    (organisationId, topicId, params) => {
      const fetchTopicUsesTime = Date.now();
      return requestor
        .get(
          `${basePath}/organisation/${organisationId}/topic/${topicId}/uses${buildQuery(
            params,
          )}`,
          {
            withCredentials: true,
          },
        )
        .then(response => ({...response.data, fetchTopicUsesTime}));
    },
  );
}
